import { UserRole } from '../../enum/UserRole';

export const rolesForProductDetails = [
  UserRole.USER,
  UserRole.SUPER_USER,
];
